import { Field, useFormikContext } from 'formik';
import { renderProductIcon } from 'legoland-sdk';
import { useEffect } from 'react';
import styled from 'styled-components';
import { Box, Checkbox, FormGroup, Text, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const validateProducts = products => {
  if (products.length > 0) {
    return {
      valid: true
    };
  } else {
    return {
      valid: false,
      reason: 'Please select at least one product'
    };
  }
};
const ProductError = styled(Text).withConfig({
  displayName: "ProductsForm__ProductError"
})(["", " margin-bottom:2sp;"], tombac.text({
  color: tombac.color('danger', 500)
}));
const ProductsBox = styled(Box).withConfig({
  displayName: "ProductsForm__ProductsBox"
})(["display:flex;justify-content:center;"]);
export const ProductsForm = ({
  products,
  setProductValidStatus
}) => {
  const {
    values
  } = useFormikContext();
  useEffect(() => {
    setProductValidStatus(validateProducts(values.productsToSend));
  }, [values]);
  return /*#__PURE__*/_jsx(Box, {
    $display: "flex",
    $mr: "4sp",
    "data-sentry-element": "Box",
    "data-sentry-component": "ProductsForm",
    "data-sentry-source-file": "ProductsForm.tsx",
    children: /*#__PURE__*/_jsx(FormGroup, {
      label: "Products",
      $mt: "4sp",
      "data-sentry-element": "FormGroup",
      "data-sentry-source-file": "ProductsForm.tsx",
      "data-sentry-element": "FormGroup",
      children: /*#__PURE__*/_jsx(ProductsBox, {
        $mt: "2sp",
        "data-sentry-element": "ProductsBox",
        "data-sentry-source-file": "ProductsForm.tsx",
        "data-sentry-element": "ProductsBox",
        children: products.length !== 0 ? products.map(product => /*#__PURE__*/_jsxs(Box, {
          $alignItems: "center",
          $display: "flex",
          as: "label",
          $mr: "7sp",
          children: [/*#__PURE__*/_jsx(Field, {
            $display: "flex",
            $mr: "1.5sp",
            as: Checkbox,
            label: false,
            name: 'productsToSend',
            value: product.id,
            checked: values.productsToSend.includes(product.id)
          }), ' ', renderProductIcon(product.id)]
        }, product.id)) : /*#__PURE__*/_jsx(ProductError, {
          children: "No available products"
        })
      })
    })
  });
};